// react-native-svg 15.16's web resolver imports
// @react-native/assets-registry/registry. React Native 0.88 does not install
// that package. This webpack build inlines images with url-loader, so there
// are no Metro numeric asset ids for getAssetByID to look up.
export function getAssetByID() {
  return null
}

export function registerAsset() {
  return 0
}
